import { Box, Stack, Typography } from "@mui/material";

type SettingsPageHeaderProps = {
  title: string;
  isDirty: boolean;
};

export const SettingsPageHeader = ({ title, isDirty }: SettingsPageHeaderProps) => {
  return (
    <Box>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h3">{title}</Typography>
        {isDirty && (
          <Typography variant="body2" sx={{ color: "#ff9800", fontWeight: "bold" }}>
            Unsaved changes
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

